/**
 * vue-outside-events @ 1.1.3
 * Nicholas Hutchind <nicholas@hutchind.com>
 *
 * Vue directive to react to various events outside the current element
 *
 * License: MIT
 */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e["vue-outside-events"] = t();
}(this, function () {
  "use strict";

  var e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
    t = function (t, i) {
      var n = {};
      return n.directiveName = t, n.eventName = i, n.bind = function (n, o, u) {
        var d = void 0 !== console.error ? console.error : console.log,
          r = null,
          v = void 0;
        if ("function" != typeof o.value) {
          if ("object" === e(o.value) && o.value.hasOwnProperty("handler") && "function" == typeof o.value.handler) r = o.value.handler, delete (v = Object.assign({}, o.value)).handler;else {
            var a = "[" + t + "]: provided expression '" + o.expression + "' must be a function or an object containing a property named 'handler' that is a function.";
            u.context.name && (a += "\nFound in component '" + u.context.name + "'"), d(a);
          }
        } else r = o.value;
        var c = function (e) {
          n.contains(e.target) || n === e.target || r(e, n, v);
        };
        n["__vueEventOutside__" + i] = c, document.addEventListener(i, c);
      }, n.unbind = function (e, t) {
        document.removeEventListener(i, e["__vueEventOutside__" + i]), e["__vueEventOutside__" + i] = null;
      }, n;
    },
    i = {
      directiveName: "event-outside",
      bind: function (t, i, n) {
        var o = void 0 !== console.error ? console.error : console.log,
          u = void 0;
        if ("object" !== e(i.value) || void 0 === i.value.name || "string" != typeof i.value.name || void 0 === i.value.handler || "function" != typeof i.value.handler) {
          var d = "[v-event-outside]: provided expression '" + i.expression + '\' must be an object containing a "name" string and a "handler" function.';
          return n.context.name && (d += "\nFound in component '" + n.context.name + "'"), void o(d);
        }
        if (delete (u = Object.assign({}, i.value)).name, delete u.handler, i.modifiers.jquery && void 0 === window.$ && void 0 === window.jQuery) {
          var r = "[v-event-outside]: jQuery is not present in window.";
          return n.context.name && (r += "\nFound in component '" + n.context.name + "'"), void o(r);
        }
        var v = function (e) {
          t.contains(e.target) || t === e.target || i.value.handler(e, t, u);
        };
        t["__vueEventOutside__" + i.value.name] = v, i.modifiers.jquery ? jQuery(document).on(i.value.name, v) : document.addEventListener(i.value.name, v);
      },
      unbind: function (e, t) {
        t.modifiers.jquery ? jQuery(document).off(t.value.name, e["__vueEventOutside__" + t.value.name]) : document.removeEventListener(t.value.name, e["__vueEventOutside__" + t.value.name]), e["__vueEventOutside__" + t.value.name] = null;
      }
    },
    n = t("click-outside", "click"),
    o = t("dblclick-outside", "dblclick"),
    u = t("focus-outside", "focusin"),
    d = t("blur-outside", "focusout"),
    r = t("mousemove-outside", "mousemove"),
    v = t("mousedown-outside", "mousedown"),
    a = t("mouseup-outside", "mouseup"),
    c = t("mouseover-outside", "mouseover"),
    s = t("mouseout-outside", "mouseout"),
    m = t("change-outside", "change"),
    l = t("select-outside", "select"),
    f = t("submit-outside", "submit"),
    p = t("keydown-outside", "keydown"),
    y = t("keypress-outside", "keypress"),
    _ = t("keyup-outside", "keyup"),
    b = {
      install: function (e) {
        e.directive(n.directiveName, n), e.directive(o.directiveName, o), e.directive(u.directiveName, u), e.directive(d.directiveName, d), e.directive(r.directiveName, r), e.directive(v.directiveName, v), e.directive(a.directiveName, a), e.directive(c.directiveName, c), e.directive(s.directiveName, s), e.directive(m.directiveName, m), e.directive(l.directiveName, l), e.directive(f.directiveName, f), e.directive(p.directiveName, p), e.directive(y.directiveName, y), e.directive(y.directiveName, y), e.directive(_.directiveName, _), e.directive(i.directiveName, i);
      }
    };
  return "undefined" != typeof window && window.Vue && window.Vue.use(b), b;
});